import { render, staticRenderFns } from "./high.vue?vue&type=template&id=1e5c4bff"
import script from "./high.vue?vue&type=script&lang=js"
export * from "./high.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports